import { ReactNode } from 'react';
import { Collapse } from 'antd';
import { DefaultInputTypes } from '../Inputs/Types';
import InputLabel from '../Inputs/InputLabel';

export type AccordionActiveKey = string | string[] | number | number[];
export interface AccordionDataDisplyProps extends DefaultInputTypes {
  panelsData: {
    title: ReactNode;
    desc: ReactNode;
    key?: string | number | undefined;
    extra?: ReactNode;
  }[];
  ExpandIcon?: React.ReactNode;
  expandIconPosition?: 'start' | 'end';
  isIconRotatable?: boolean;
  panelStyle?: string;
  collapseStyle?: string;
  expandIconStyle?: string;
  activeKey?: AccordionActiveKey;
  onChange?: (key: AccordionActiveKey) => void;
}

const { Panel } = Collapse;

const AccordionDataDisply = ({
  label,
  name,
  panelsData,
  ExpandIcon,
  expandIconPosition,
  isIconRotatable,
  panelStyle,
  collapseStyle,
  expandIconStyle,
  activeKey,
  onChange,
}: AccordionDataDisplyProps) => {
  return (
    <div>
      {label && <InputLabel name={name} text={label} />}
      {panelsData.length ? (
        <Collapse
          expandIcon={({ isActive }) => (
            <div className={`w-full ${expandIconStyle}`}>
              <div
                className={`min-w-[12px]`}
                style={{
                  transform:
                    isActive && isIconRotatable
                      ? `rotate(180deg)`
                      : `rotate(0)`,
                }}
              >
                {ExpandIcon}
              </div>
            </div>
          )}
          expandIconPosition={expandIconPosition}
          activeKey={activeKey}
          onChange={onChange}
          className={collapseStyle}
          style={{ WebkitTapHighlightColor: 'transparent' }}
        >
          {panelsData.map((item, i) => (
            <Panel
              header={item.title}
              key={item.key || i}
              extra={item.extra}
              className={panelStyle}
              style={{ WebkitTapHighlightColor: 'transparent' }}
            >
              {item.desc}
            </Panel>
          ))}
        </Collapse>
      ) : null}
    </div>
  );
};

export default AccordionDataDisply;
